import { makeStyles } from '@material-ui/core';
import { Image, Layout } from 'antd';
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import Loader from 'src/component/Loader/Loader';
import formatDate from 'src/helpers/formatDate';
import { useGetBoxes } from 'src/reactQuery/box/useGetBoxes';

const useStyles = makeStyles({
  headers: {
    '& > p': {
      color: '#9ba0ad',
      overflowWrap: 'break-word'
    },
    alignItems: 'center',
    borderBottom: '1px solid #f1f4fe',
    display: 'grid',
    gridTemplateColumns: '33% 22% 22% 22%',
    height: '70px',
    justifyItems: 'start'
  },
  image: {
    borderRadius: '8px',
    height: '48px',
    objectFit: 'cover',
    width: '48px'
  },
  inventoryImages: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '8px',
    maxWidth: '216px',
    width: '216px'
  },
  inventoryItem: {
    alignItems: 'center',
    borderBottom: '1px solid #f1f4fe',
    display: 'grid',
    gridTemplateColumns: '33% 22% 22% 22%',
    padding: '10px 0px'
  },
  noInventory: {
    color: '#9ba0ad',
    fontSize: '20px',
    fontWeight: 500,
    textAlign: 'center'
  }
});

interface InventoryData {
  createdAt: string;
  description: string;
  images: {
    name: string;
    size: number;
    src: string;
  }[];
  name: string;
}

const Inventory = () => {
  const { data, isLoading } = useGetBoxes();
  // @ts-ignore
  const { customerId } = useParams();
  const classes = useStyles();
  const inventoryData: InventoryData[] | undefined = useMemo(() => {
    if (!data) {
      return [];
    }

    const filteredBoxes = data.data.filter((box) => box.type === 'INTRANET_RESPONSIBILITIES');

    const filteredBoxesByUser = filteredBoxes.filter((box) => box.user === customerId);

    const responsibilities: InventoryData[] = filteredBoxesByUser.map((inventoryBox) => {
      // @ts-ignore
      return { ...inventoryBox.data, createdAt: inventoryBox.createdAt };
    });
    return responsibilities;
  }, [data]);

  if (!inventoryData || isLoading) {
    return <Loader />;
  }

  return (
    <Layout
      style={{
        background: 'white',
        borderTop: '1px solid #9BA0AD',
        marginTop: '20px'
      }}
    >
      <div
        style={{
          alignItems: 'center',
          display: 'flex',
          justifyContent: 'space-between',
          padding: '35px 40px 0px 35px'
        }}
      >
        <div
          style={{
            fontFamily: 'Poppins',
            fontSize: '38px'
          }}
        >
          Inventory
        </div>
      </div>

      <div
        style={{
          padding: '0px 40px 0px 35px',
          textAlign: 'start'
        }}
      >
        {inventoryData.length === 0 ? (
          <p className={classes.noInventory}>No inventory found</p>
        ) : (
          <>
            <div className={classes.headers}>
              <p>Images</p>
              <p>Name</p>
              <p>Description</p>
              <p>Created At</p>
            </div>
            {inventoryData.map((item, index) => {
              return (
                <div key={index} className={classes.inventoryItem}>
                  <div className={classes.inventoryImages}>
                    {item.images.map((image, imageIndex) => {
                      return <Image key={imageIndex} className={classes.image} src={image.src} />;
                    })}
                  </div>

                  <div>{item.name}</div>
                  <div>{item.description}</div>
                  <div>{formatDate(item.createdAt)}</div>
                </div>
              );
            })}
          </>
        )}
      </div>
    </Layout>
  );
};

export default Inventory;
